import React from 'react';
import classNames from 'classnames';
import { RichText } from '../../components/rich-text';

export class PageHeader extends React.Component {
  componentDidMount () {
    console.log(this.props.content);
  }

  render = () => (
    <div className="page-header">
      <div className="page-header__left">{this.props.title}</div>
      <div className="page-header__right">
        { this.props.content && <RichText raw={this.props.content.raw} /> }
      </div>
    </div>
  )
}